import Link from 'next/link';
import React from 'react';
import FullWidthContainer from '../Layout/Containers/FullWidthContainer';
import ImageAndTextContainer from '../Layout/Containers/ImageAndTextContainer/ImageAndTextContainer';
import styles from './aboutUs.module.scss';

const AboutUsComponent = () => (
    <section>
        <FullWidthContainer extraClassNames={styles.noriaIntroduction}>
            <ImageAndTextContainer
                ingress="We specialise in digital and IT for financial services"
                ingressSize="big"
                h1={true}
                paragraphSize="big"
                pictureFirstOrLast="last"
                image={{
                    src: '/images/about/about_2.jpg',
                    alt: '',
                    maxWidth: 758,
                    maxHeight: 567,
                }}
                isIngressTop={true}
            >
                Noria represents a unique combination of competencies with expertise in financial
                services, technology and design. In close collaboration with our customers, we drill
                down to the core of their needs to help them succeed on their digital journeys. Our
                dedicated project teams provide support from idea to launch to enable you to deliver
                real value to your end customer.
            </ImageAndTextContainer>
        </FullWidthContainer>
        <FullWidthContainer extraClassNames={styles.backgroundImageCircle}>
            <ImageAndTextContainer
                ingress="We are curious"
                image={{
                    src: '/videos/curious.mp4',
                    alt: '',
                    maxWidth: 758,
                    maxHeight: 567,
                }}
                isVideo={true}
                isInvertedOnMobile={true}
            >
                Our culture and mission is to <i>be, act and stay curious</i>. After all, most of
                the great discoveries and inventions throughout history are the result of curiosity.
                The impulse to seek new information and experiences and explore possibilities is a
                basic human attribute, and our core value in Noria.
                <br />
                <br />
                A curious mindset encourages us to always seek out opportunities for improvement. It
                makes us inquisitive and relentless in our research. It opens us up to other
                people's opinions about our ideas and our work. It also inspires us to develop more
                trusting and collaborative relationships with colleagues and clients.
                <br />
                <br />
                At Noria we aim to bring curiosity into every aspect of our work. It reminds us to
                always challenge the status quo in order to deliver great projects and solutions for
                our customers.
            </ImageAndTextContainer>
        </FullWidthContainer>
        <FullWidthContainer>
            <ImageAndTextContainer
                ingress="We partner with ambitious brands, big and small"
                pictureFirstOrLast="last"
                image={{
                    src: '/images/about/about_4.jpg',
                    alt: '',
                    maxWidth: 758,
                    maxHeight: 567,
                }}
                extraClassNames={styles.servicesExtraPadding}
            >
                <>
                    We pride ourselves on being a one-stop shop. Combining our robust software
                    solutions platform with our trusted service offering, Noria works with fintech
                    start-ups, mid-sized companies and established institutions in the financial
                    services market. Working this broadly across the value chain keeps us agile and
                    balanced in how we can best deliver value for our wide range of clients.
                    <Link href="/solutions-and-services" title="View our solutions and services">
                        <span>View our solutions and services</span>
                    </Link>
                </>
            </ImageAndTextContainer>
        </FullWidthContainer>
        <FullWidthContainer>
            <div className={styles.inTouch}>
                <span className={styles.inTouchHeader}>Have a project in mind?</span>
                <span className={styles.inTouchPunch}>We'd love to hear from you.</span>
                <Link href="/contact" className="button-link" title="Go to contact page">
                    <span>Get in touch</span>
                </Link>
            </div>
        </FullWidthContainer>
    </section>
);

export default AboutUsComponent;
